import { render, staticRenderFns } from "./ChangeEventDetail.vue?vue&type=template&id=249f2b88&scoped=true&"
import script from "./ChangeEventDetail.vue?vue&type=script&lang=js&"
export * from "./ChangeEventDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChangeEventDetail.vue?vue&type=style&index=0&id=249f2b88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249f2b88",
  null
  
)

export default component.exports